export default function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  'ngInject'

  $locationProvider.html5Mode(true)
  $locationProvider.hashPrefix('!')
  $urlRouterProvider.otherwise('/')
  $urlRouterProvider.when('/admin/all_sales', '/admin/all_sales/transactions')
  $urlRouterProvider.when('/admin/all_sales/', '/admin/all_sales/transactions')

  $stateProvider

    .state('start', {
      url: '/',
      views: {
        '@': {
          controller: 'IndexCtrl as vm',
        },
      },
    })

    .state('signin', {
      url: '/signin',
      views: {
        '@': {
          templateUrl: 'app/signin/signin.html',
          controller: 'SigninCtrl as vm',
        },
      },
    })

    .state('signup', {
      url: '/signup',
      views: {
        '@': {
          templateUrl: 'app/signup/signup.html',
          controller: 'SignupCtrl as vm',
        },
      },
    })

    /**
     * Admin routers
     */
    .state('admin', {
      url: '/admin',
      abtract: true,
    })

    .state('admin.home', {
      url: '/home',
      views: {
        '@': {
          templateUrl: 'app/admin/home/home.html',
          controller: 'HomeAdminCtrl as vm',
        },
      },
    })

    .state('admin.communities', {
      url: '/communities',
      views: {
        '@': {
          templateUrl: 'app/admin/communities/communities.html',
          controller: 'CommunitiesCtrl as vm',
        },
      },
    })

    .state('admin.communities.posts', {
      url: '/:parentId/posts',
      views: {
        '@': {
          templateUrl: 'app/admin/communities/posts/posts.html',
          controller: 'CommunitiesPostsCtrl as vm',
        },
      },
    })

    .state('admin.communities.post_hidden', {
      url: '/post_hidden',
      views: {
        '@': {
          templateUrl: 'app/admin/communities/post_hidden/post_hidden.html',
          controller: 'CommunitiesPostsHiddenCtrl as vm',
        },
      },
    })

    .state('admin.publishers', {
      url: '/publishers',
      views: {
        '@': {
          templateUrl: 'app/admin/publishers/publishers.html',
          controller: 'PublisherAdminCtrl as vm',
        },
      },
    })

    .state('admin.publishers.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/publishers/edit/edit.html',
          controller: 'PublisherAdminEditCtrl as vm',
        },
      },
    })

    .state('admin.event', {
      url: '/event',
      views: {
        '@': {
          templateUrl: 'app/admin/event/event.html',
          controller: 'EventCtrl as vm',
        },
      },
    })

    .state('admin.permissions', {
      url: '/permissions',
      views: {
        '@': {
          templateUrl: 'app/admin/permissions/permissions.html',
          controller: 'PermissionsCtrl as vm',
        },
      },
    })

    .state('admin.hashtags', {
      url: '/hashtags',
      views: {
        '@': {
          templateUrl: 'app/admin/hashtags/hashtags.html',
          controller: 'HashtagsCtrl as vm',
        },
      },
    })

    .state('admin.explore', {
      url: '/explore',
      views: {
        '@': {
          templateUrl: 'app/admin/explore/explore.html',
          controller: 'ExploreCtrl as vm',
        },
      },
    })

    .state('admin.explore.customchannel', {
      url: '/:id/custom_channel',
      views: {
        '@': {
          templateUrl: 'app/admin/explore/custom_channel/customchannel.html',
          controller: 'ExploreCustomChannelCtrl as vm',
        },
      },
    })

    .state('admin.explore.customset', {
      url: '/:id/custom_set',
      views: {
        '@': {
          templateUrl: 'app/admin/explore/custom_set/customset.html',
          controller: 'ExploreCustomSetCtrl as vm',
        },
      },
    })

    .state('admin.explore.custombundle', {
      url: '/:id/custom_bundle',
      views: {
        '@': {
          templateUrl: 'app/admin/explore/custom_bundle/custombundle.html',
          controller: 'ExploreCustomBundleCtrl as vm',
        },
      },
    })

    .state('admin.explore.customfeature', {
      url: '/:id/custom_feature',
      views: {
        '@': {
          templateUrl: 'app/admin/explore/custom_feature/customfeature.html',
          controller: 'ExploreCustomFeatureCtrl as vm',
        },
      },
    })

    // .state("admin.notifications", {
    //   url: "/notifications/:userId",
    //   views: {
    //     "@": {
    //       templateUrl: "app/admin/notifications/notifications.html",
    //       controller: "NotificationsCtrl as vm",
    //     },
    //   },
    // })

    .state('admin.awards', {
      url: '/awards',
      views: {
        '@': {
          templateUrl: 'app/admin/awards/awards.html',
          controller: 'AwardsCtrl as vm',
        },
      },
    })

    .state('admin.awards.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/awards/edit/edit.html',
          controller: 'AwardsEditCtrl as vm',
        },
      },
    })

    .state('admin.checklist', {
      url: '/checklist',
      views: {
        '@': {
          templateUrl: 'app/admin/checklist/checklist.html',
          controller: 'ChecklistCtrl as vm',
        },
      },
    })

    .state('admin.checklist.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/checklist/edit/edit.html',
          controller: 'ChecklistEditCtrl as vm',
        },
      },
    })

    .state('admin.checklist.empty', {
      url: '/:id/empty',
      views: {
        '@': {
          templateUrl: 'app/admin/checklist/empty/empty.html',
          controller: 'ChecklistEmptyStateEditCtrl as vm',
        },
      },
    })

    .state('admin.checklist.users', {
      url: '/:id/users',
      views: {
        '@': {
          templateUrl: 'app/admin/checklist/users/users.html',
          controller: 'ChecklistUsersCtrl as vm',
        },
      },
    })

    .state('admin.notification_history', {
      url: '/notification_history',
      views: {
        '@': {
          templateUrl: 'app/admin/notification_history/notification_history.html',
          controller: 'NotificationHistoryAdminCtrl as vm',
        },
      },
    })

    .state('admin.notification_history.edit', {
      url: '/edit/:id?event&create',
      views: {
        '@': {
          templateUrl: 'app/admin/notification_history/edit/edit.html',
          controller: 'NotificationHistoryEditAdminCtrl as vm',
        },
      },
    })

    .state('admin.publishers.details', {
      url: '/publishers/details/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/publishers/details/details.html',
          controller: 'PublisherDetailCtrl as vm',
        },
      },
    })

    .state('admin.publishers.users', {
      url: '/:parentId/users',
      views: {
        '@': {
          templateUrl: 'app/admin/publishers/users/users.html',
          controller: 'PublisherUserAdminCtrl as vm',
        },
      },
    })

    .state('admin.publishers.users.view', {
      url: '/:parentId/users/view',
      views: {
        '@': {
          templateUrl: 'app/admin/publishers/users/users.html',
          controller: 'PublisherUserAdminCtrl as vm',
        },
      },
    })

    .state('admin.users', {
      url: '/users',
      views: {
        '@': {
          templateUrl: 'app/admin/users/users.html',
          controller: 'UserAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details', {
      url: '/:parentId/details',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/details.html',
          controller: 'UserDetailsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.profile', {
      url: '/profile',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/profile/profile.html',
          controller: 'ProfileUserCtrl as vm',
        },
      },
    })

    .state('admin.users.details.restrictions', {
      url: '/:parentId/restrictions',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/restrictions/restrictions.html',
          controller: 'RestrictionsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.reports', {
      url: '/reports',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/reports/reports.html',
          controller: 'ReportsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.comments', {
      url: '/comments',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/comments/comments.html',
          controller: 'CommentsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.favorites', {
      url: '/favorites',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/favorites/favorites.html',
          controller: 'FavoritesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.messages', {
      url: '/messages',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/messages/messages.html',
          controller: 'MessagesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.messages.details', {
      url: '/details/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/messages/details/details.html',
          controller: 'MessagesDetailsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.items', {
      url: '/items/:username',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/items/items.html',
          controller: 'ItemsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.collections', {
      url: '/collections/:username',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/collections/collections.html',
          controller: 'CollectionsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.collections.sets', {
      url: '/:channelId/sets',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/collections/sets/sets.html',
          controller: 'CollectionsSetsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.collections.sets.prints', {
      url: '/:setId/prints',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/collections/prints/prints.html',
          controller: 'CollectionsSetsPrintsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.devices', {
      url: '/devices',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/devices/devices.html',
          controller: 'DevicesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.ips', {
      url: '/ips/:ip',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/ips/ips.html',
          controller: 'IPsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.showcases', {
      url: '/showcases',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/showcases/showcases.html',
          controller: 'ShowcasesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.friends', {
      url: '/friends',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/friends/friends.html',
          controller: 'FriendsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.purchases', {
      url: '/purchases',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/purchases/purchases.html',
          controller: 'PurchasesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.wallets', {
      url: '/wallets',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/wallets/wallets.html',
          controller: 'WalletsAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.blockchain_address', {
      url: '/blockchain_address',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/blockchain_address/blockchain_address.html',
          controller: 'BlockchainAddressCtrl as vm',
        },
      },
    })

    .state('admin.users.details.username_changes', {
      url: '/username_changes',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/username_changes/username_changes.html',
          controller: 'UsernameChangesCtrl as vm',
        },
      },
    })

    .state('admin.users.details.email_changes', {
      url: '/email_changes',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/email_changes/email_changes.html',
          controller: 'EmailChangesCtrl as vm',
        },
      },
    })

    .state('admin.users.details.user_lock_logs', {
      url: '/user_lock_logs',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/user_lock_logs/user_lock_logs.html',
          controller: 'UserLockLogsCtrl as vm',
        },
      },
    })

    .state('admin.users.details.ledgers', {
      url: '/ledgers',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/ledger/ledger.html',
          controller: 'LedgersAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.ledgers.bundles', {
      url: '/:bpId/:setId/bundles/:bundleId',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/ledger/bundle/bundle.html',
          controller: 'LedgersBundlesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.cash_ledgers', {
      url: '/cash_ledgers',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/cash_ledger/cash_ledger.html',
          controller: 'CashLedgersAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.cash_ledgers.bundles', {
      url: '/:bpId/:setId/bundles/:bundleId',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/cash_ledger/bundle/bundle.html',
          controller: 'CashLedgersBundlesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.inviters', {
      url: '/inviters',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/inviters/inviters.html',
          controller: 'InvitersAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.roles', {
      url: '/roles',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/roles/roles.html',
          controller: 'UserRolesCtrl as vm',
        },
      },
    })

    .state('admin.users.details.notes', {
      url: '/notes',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/notes/notes.html',
          controller: 'NotesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.trades', {
      url: '/trades',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/trades/trades.html',
          controller: 'UserTradesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.trades.details', {
      url: '/details',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/trades/details/details.html',
          controller: 'UserTradesDetailsAdminCtrl as vm',
        },
      },
      params: { details: null },
    })

    .state('admin.users.details.listing_buyer', {
      url: '/listing_buyer',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/listing_buyer/listing_buyer.html',
          controller: 'ListingBuyerAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.listing_seller', {
      url: '/listing_seller',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/listing_seller/listing_seller.html',
          controller: 'ListingSellerAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.promocodes', {
      url: '/promocodes',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/promocodes/promocodes.html',
          controller: 'PromoCodesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.shelfies', {
      url: '/shelfies',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/shelfies/shelfies.html',
          controller: 'ShelfiesAdminCtrl as vm',
        },
      },
    })

    .state('admin.users.details.print_escrows', {
      url: '/print_escrows',
      views: {
        '@': {
          templateUrl: 'app/admin/users/details/print_escrows/print_escrows.html',
          controller: 'PrintEscrowsUserCtrl as vm',
        },
      },
    })

    .state('admin.suggested_account', {
      url: '/suggested_account',
      views: {
        '@': {
          templateUrl: 'app/admin/suggested_account/suggested_account.html',
          controller: 'SuggestedAccountsCtrl as vm',
        },
      },
    })

    .state('admin.withdrawals', {
      url: '/withdrawals',
      views: {
        '@': {
          templateUrl: 'app/admin/withdrawals/withdrawals.html',
          controller: 'WithdrawalsAdminCtrl as vm',
        },
      },
    })

    .state('admin.blockchains', {
      url: '/blockchains',
      views: {
        '@': {
          templateUrl: 'app/admin/blockchain/blockchain.html',
          controller: 'BlockchainCtrl as vm',
        },
      },
    })

    .state('admin.marketplaces', {
      url: '/marketplaces',
      views: {
        '@': {
          templateUrl: 'app/admin/marketplace/marketplace.html',
          controller: 'MarketplaceCtrl as vm',
        },
      },
    })

    .state('admin.genres', {
      url: '/genres',
      views: {
        '@': {
          templateUrl: 'app/admin/genres/genres.html',
          controller: 'GenresCtrl as vm',
        },
      },
    })

    .state('admin.genres.channels', {
      url: '/:id/channels',
      views: {
        '@': {
          templateUrl: 'app/admin/genres/channels/channels.html',
          controller: 'GenresChannelsCtrl as vm',
        },
      },
    })

    .state('admin.genres.orders', {
      url: '/:id/orders',
      views: {
        '@': {
          templateUrl: 'app/admin/genres/orders/orders.html',
          controller: 'GenresChannelsOrdersCtrl as vm',
        },
      },
    })

    .state('admin.product_categories', {
      url: '/product-categories',
      views: {
        '@': {
          templateUrl: 'app/admin/product_categories/product_categories.html',
          controller: 'ProductCategoriesCtrl as vm',
        },
      },
    })

    .state('admin.product_categories.product_subcategories', {
      url: '/:parentId/product-subcategories',
      views: {
        '@': {
          templateUrl:
            'app/admin/product_categories/product_subcategories/product_subcategories.html',
          controller: 'ProductSubCategoriesCtrl as vm',
        },
      },
    })

    .state('admin.compatible_apps', {
      url: '/compatible_apps',
      views: {
        '@': {
          templateUrl: 'app/admin/compatible_app/compatible_app.html',
          controller: 'CompatibleAppCtrl as vm',
        },
      },
    })

    .state('admin.scheduled_messages', {
      url: '/scheduled_messages',
      views: {
        '@': {
          templateUrl: 'app/admin/scheduled_message/scheduled_message.html',
          controller: 'ScheduledMessageAppCtrl as vm',
        },
      },
    })

    .state('admin.product', {
      url: '/products',
      views: {
        '@': {
          templateUrl: 'app/admin/product/product.html',
          controller: 'ProductAdminCtrl as vm',
        },
      },
    })

    .state('admin.channel_group', {
      url: '/channel_group',
      views: {
        '@': {
          templateUrl: 'app/admin/channel_group/channel_group.html',
          controller: 'ChannelGroupAdminCtrl as vm',
        },
      },
    })

    .state('admin.channel_group.children', {
      url: '/channel/:parentId',
      views: {
        '@': {
          templateUrl: 'app/admin/channel_group/channel/channel.html',
          controller: 'ChannelGroupChildrenAdminCtrl as vm',
        },
      },
    })

    .state('admin.product_lines', {
      url: '/product_lines',
      views: {
        '@': {
          templateUrl: 'app/admin/product_lines/product_lines.html',
          controller: 'ProductLinesAdminCtrl as vm',
        },
      },
    })

    .state('admin.product.edit', {
      url: '/edit/:id?type',
      views: {
        '@': {
          templateUrl: 'app/admin/product/edit/edit.html',
          controller: 'ProductEditCtrl as vm',
        },
      },
    })

    .state('admin.versions', {
      url: '/versions',
      views: {
        '@': {
          templateUrl: 'app/admin/versions/versions.html',
          controller: 'VersionsAdminCtrl as vm',
        },
      },
    })

    .state('admin.sync_data', {
      url: '/sync_data',
      views: {
        '@': {
          templateUrl: 'app/admin/sync_data/sync_data.html',
          controller: 'SyncDataAdminCtrl as vm',
        },
      },
    })

    .state('admin.logs', {
      url: '/logs',
      views: {
        '@': {
          templateUrl: 'app/admin/logs/logs.html',
          controller: 'LogsAdminCtrl as vm',
        },
      },
    })

    .state('admin.tips', {
      url: '/tips',
      views: {
        '@': {
          templateUrl: 'app/admin/tips/tips.html',
          controller: 'TipsAdminCtrl as vm',
        },
      },
    })

    .state('admin.tips.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/tips/edit/edit.html',
          controller: 'TipsAdminEditCtrl as vm',
        },
      },
    })

    .state('admin.posts', {
      url: '/posts',
      views: {
        '@': {
          templateUrl: 'app/admin/posts/posts.html',
          controller: 'PostsAdminCtrl as vm',
        },
      },
    })

    .state('admin.posts.edit', {
      url: '/:id/edit?returnUrl',
      views: {
        '@': {
          templateUrl: 'app/admin/posts/edit/edit.html',
          controller: 'PostsAdminEditCtrl as vm',
        },
      },
    })

    .state('admin.posts.comments', {
      url: '/:parentId/comments?returnUrl',
      views: {
        '@': {
          templateUrl: 'app/admin/posts/comments/comments.html',
          controller: 'PostCommentsAdminCtrl as vm',
        },
      },
    })

    .state('admin.posts.logs', {
      url: '/:parentId/logs?returnUrl',
      views: {
        '@': {
          templateUrl: 'app/admin/posts/logs/logs.html',
          controller: 'PostLogsAdminCtrl as vm',
        },
      },
    })

    .state('admin.posts.blocked_users', {
      url: '/:parentId/blocked_users?returnUrl',
      views: {
        '@': {
          templateUrl: 'app/admin/posts/blocked_users/blocked_users.html',
          controller: 'PostBlockedUsersCtrl as vm',
        },
      },
    })

    .state('admin.posts.blocked_user_comments', {
      url: '/:parentId/blocked_user_comments?returnUrl',
      views: {
        '@': {
          templateUrl: 'app/admin/posts/blocked_user_comments/blocked_user_comments.html',
          controller: 'PostBlockedUserCommentsCtrl as vm',
        },
      },
    })

    .state('admin.tags', {
      url: '/tags',
      views: {
        '@': {
          templateUrl: 'app/admin/tags/tags.html',
          controller: 'TagsAdminCtrl as vm',
        },
      },
    })

    .state('admin.trades', {
      url: '/trades',
      views: {
        '@': {
          templateUrl: 'app/admin/trades/trades.html',
          controller: 'TradesAdminCtrl as vm',
        },
      },
    })

    .state('admin.all_sales', {
      url: '/all_sales',
      abstract: true,
      views: {
        '@': {
          templateUrl: 'app/admin/all_sales/all_sales.html',
          controller: 'AllSalesAdminCtrl as vm',
        },
      },
    })
    .state('admin.all_sales.transactions', {
      url: '/transactions',
      templateUrl: 'app/admin/all_sales/tabs/transactions/transactions.html',
      controller: 'TransactionsCtrl as vm',
    })
    .state('admin.all_sales.accounting', {
      url: '/accounting',
      templateUrl: 'app/admin/all_sales/tabs/accounting/accounting.html',
      controller: 'AccountingCtrl as vm',
    })
    .state('admin.all_sales.user_analytics', {
      url: '/user-analytics',
      templateUrl: 'app/admin/all_sales/tabs/user_analytics/user_analytics.html',
      controller: 'UserAnalyticsCtrl as vm',
    })

    .state('admin.wash_trades', {
      url: '/wash_trades',
      views: {
        '@': {
          templateUrl: 'app/admin/wash_trades/wash_trades.html',
          controller: 'WashTradesAdminCtrl as vm',
        },
      },
    })

    .state('admin.winners', {
      url: '/winners',
      views: {
        '@': {
          templateUrl: 'app/admin/winners/winners.html',
          controller: 'WinnersAdminCtrl as vm',
        },
      },
    })

    .state('admin.configurations', {
      url: '/configurations',
      views: {
        '@': {
          templateUrl: 'app/admin/configurations/configurations.html',
          controller: 'ConfigurationsCtrl as vm',
        },
      },
    })

    .state('admin.storyboard_events', {
      url: '/storyboard_events',
      views: {
        '@': {
          templateUrl: 'app/admin/storyboard_event/storyboard_event.html',
          controller: 'StoryboardEventCtrl as vm',
        },
      },
    })

    .state('admin.scheduled_configurations', {
      url: '/scheduled_configurations',
      views: {
        '@': {
          templateUrl: 'app/admin/scheduled_configurations/scheduled_configurations.html',
          controller: 'ScheduledConfigurationsCtrl as vm',
        },
      },
    })

    .state('admin.audiences', {
      url: '/audiences',
      views: {
        '@': {
          templateUrl: 'app/admin/audiences/audiences.html',
          controller: 'AudiencesCtrl as vm',
        },
      },
    })

    .state('admin.ambassador_giveaway', {
      url: '/ambassador_giveaway',
      views: {
        '@': {
          templateUrl: 'app/admin/ambassador_giveaway/ambassador_giveaway.html',
          controller: 'AmbassadorGiveawayAdminCtrl as vm',
        },
      },
    })

    .state('admin.print_escrow', {
      url: '/print_escrow',
      views: {
        '@': {
          templateUrl: 'app/admin/print_escrow/print_escrow.html',
          controller: 'PrintEscrowAdminCtrl as vm',
        },
      },
    })

    .state('admin.print_transfer_log', {
      url: '/print_transfer_log/:id/edit?printIds',
      views: {
        '@': {
          templateUrl: 'app/admin/print_escrow/edit/edit.html',
          controller: 'PrintTransferLogEditCtrl as vm',
        },
      },
    })

    .state('admin.prints', {
      url: '/prints?collectibleId&edition&printNumber',
      views: {
        '@': {
          templateUrl: 'app/admin/print_history/print_history.html',
          controller: 'PrintAdminCtrl as vm',
        },
      },
    })

    .state('admin.email_management', {
      url: '/email_management',
      views: {
        '@': {
          templateUrl: 'app/admin/email_management/email_management.html',
          controller: 'EmailManagementCtrl as vm',
        },
      },
    })

    .state('admin.print_lookup', {
      url: '/print_lookup',
      views: {
        '@': {
          templateUrl: 'app/admin/print_lookup/print_lookup.html',
          controller: 'PrintLookupCtrl as vm',
        },
      },
    })

    .state('admin.lookup', {
      url: '/lookup',
      views: {
        '@': {
          templateUrl: 'app/admin/lookup/lookup.html',
          controller: 'LookupCtrl as vm',
        },
      },
    })

    .state('admin.shinie_redemption', {
      url: '/shinie_redemption',
      views: {
        '@': {
          templateUrl: 'app/admin/shinie_redemption/shinies.html',
          controller: 'ShiniesRedemptionCtrl as vm',
        },
      },
    })

    .state('admin.shinies', {
      url: '/shinies',
      views: {
        '@': {
          templateUrl: 'app/admin/shinies/shinies.html',
          controller: 'ShiniesAdminCtrl as vm',
        },
      },
    })

    .state('admin.shinies.users', {
      url: '/:id/users',
      views: {
        '@': {
          templateUrl: 'app/admin/shinies/users/users.html',
          controller: 'ShiniesUsersAdminCtrl as vm',
        },
      },
    })

    .state('admin.checklist_report', {
      url: '/checklist_report',
      views: {
        '@': {
          templateUrl: 'app/admin/checklist_report/checklist_report.html',
          controller: 'ChecklistReportCtrl as vm',
        },
      },
    })

    .state('admin.profile', {
      url: '/profile',
      views: {
        '@': {
          templateUrl: 'app/admin/profile/profile.html',
          controller: 'ProfileAdminCtrl as vm',
        },
      },
    })

    .state('admin.features', {
      url: '/features',
      views: {
        '@': {
          templateUrl: 'app/admin/features/features.html',
          controller: 'FeaturesCtrl as vm',
        },
      },
    })

    .state('admin.features.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/features/edit/edit.html',
          controller: 'FeaturesEditCtrl as vm',
        },
      },
    })

    .state('admin.offers', {
      url: '/offers',
      views: {
        '@': {
          templateUrl: 'app/admin/offers/offers.html',
          controller: 'OffersCtrl as vm',
        },
      },
    })

    .state('admin.offers.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/offers/edit/edit.html',
          controller: 'OffersEditCtrl as vm',
        },
      },
    })

    .state('admin.mini_game_configurations', {
      url: '/mini_game_configurations',
      views: {
        '@': {
          templateUrl: 'app/admin/mini_game_configurations/mini_game_configurations.html',
          controller: 'MiniGameConfigurationsCtrl as vm',
        },
      },
    })

    .state('admin.mini_game_configurations.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/mini_game_configurations/edit/edit.html',
          controller: 'MiniGameConfigurationsEditCtrl as vm',
        },
      },
    })

    .state('admin.rewards', {
      url: '/rewards',
      views: {
        '@': {
          templateUrl: 'app/admin/rewards/rewards.html',
          controller: 'RewardsCtrl as vm',
        },
      },
    })

    .state('admin.rewards.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/rewards/edit/edit.html',
          controller: 'RewardsEditCtrl as vm',
        },
      },
    })

    .state('admin.channel_hero_banners', {
      url: '/channel_hero_banners',
      views: {
        '@': {
          templateUrl: 'app/admin/channel_hero_banners/channel_hero_banners.html',
          controller: 'ChannelHeroBannersCtrl as vm',
        },
      },
    })

    .state('admin.channel_hero_banners.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/channel_hero_banners/edit/edit.html',
          controller: 'ChannelHeroBannersEditCtrl as vm',
        },
      },
    })

    .state('admin.daily_login_banners', {
      url: '/daily_login_banners',
      views: {
        '@': {
          templateUrl: 'app/admin/daily_login_banners/daily_login_banners.html',
          controller: 'DailyLoginBannerCtrl as vm',
        },
      },
    })

    .state('admin.daily_login_banners.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/daily_login_banners/edit/edit.html',
          controller: 'DailyLoginBannerEditCtrl as vm',
        },
      },
    })

    .state('admin.channel_prize_banners', {
      url: '/channel_prize_banners',
      views: {
        '@': {
          templateUrl: 'app/admin/channel_prize_banners/channel_prize_banners.html',
          controller: 'ChannelPrizeBannersCtrl as vm',
        },
      },
    })
    .state('admin.channel_prize_banners.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/channel_prize_banners/edit/edit.html',
          controller: 'ChannelPrizeBannersEditCtrl as vm',
        },
      },
    })

    .state('admin.default_bounty_shinies', {
      url: '/default_bounty_shinies',
      views: {
        '@': {
          templateUrl: 'app/admin/default_bounty_shinies/default_bounty_shinies.html',
          controller: 'DefaultBountyShiniesCtrl as vm',
        },
      },
    })

    .state('admin.default_bounty_shinies.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/default_bounty_shinies/edit/edit.html',
          controller: 'DefaultBountyShiniesEditCtrl as vm',
        },
      },
    })

    .state('admin.deposit_match', {
      url: '/deposit_match',
      views: {
        '@': {
          templateUrl: 'app/admin/deposit_match/deposit_match.html',
          controller: 'DepositMatchCtrl as vm',
        },
      },
    })

    .state('admin.deposit_match.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/deposit_match/edit/edit.html',
          controller: 'DepositMatchEditCtrl as vm',
        },
      },
    })

    .state('admin.affiliates', {
      url: '/affiliates',
      views: {
        '@': {
          templateUrl: 'app/admin/affiliates/affiliates.html',
          controller: 'AffiliatesCtrl as vm',
        },
      },
    })

    .state('admin.affiliates.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/affiliates/edit/edit.html',
          controller: 'AffiliatesEditCtrl as vm',
        },
      },
    })

    .state('admin.collector_levels', {
      url: '/collector_levels',
      views: {
        '@': {
          templateUrl: 'app/admin/collector_levels/collector_levels.html',
          controller: 'CollectorLevelsCtrl as vm',
        },
      },
    })

    .state('admin.collector_levels.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/collector_levels/edit/edit.html',
          controller: 'CollectorLevelsEditCtrl as vm',
        },
      },
    })

    .state('admin.subscription', {
      url: '/subscription',
      views: {
        '@': {
          templateUrl: 'app/admin/subscription/subscription.html',
          controller: 'SubscriptionCtrl as vm',
        },
      },
    })

    .state('admin.user_segmentation', {
      url: '/user_segmentation',
      views: {
        '@': {
          templateUrl: 'app/admin/user_segmentation/user_segmentation.html',
          controller: 'UserSegmentationCtrl as vm',
        },
      },
    })

    .state('admin.user_segmentation.manager', {
      url: '/:id',
      params: {
        id: { value: null, squash: true },
      },
      views: {
        '@': {
          templateUrl: 'app/admin/user_segmentation/manager/manager.html',
          controller: 'UserSegmentationManagerCtrl as vm',
        },
      },
    })

    .state('admin.coupons', {
      url: '/coupons',
      views: {
        '@': {
          templateUrl: 'app/admin/coupons/coupons.html',
          controller: 'CouponsCtrl as vm',
        },
      },
    })

    .state('admin.coupons.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/coupons/edit/edit.html',
          controller: 'CouponsEditCtrl as vm',
        },
      },
    })

    .state('admin.promo_campaigns', {
      url: '/promo_campaigns',
      views: {
        '@': {
          templateUrl: 'app/admin/campaigns/campaigns.html',
          controller: 'CampaignsCtrl as vm',
        },
      },
    })

    .state('admin.promo_campaigns.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/campaigns/edit/edit.html',
          controller: 'CampaignsEditCtrl as vm',
        },
      },
    })

    .state('admin.promo_campaigns.promo', {
      url: '/:parentId/promo',
      views: {
        '@': {
          templateUrl: 'app/admin/campaigns/promos/promos.html',
          controller: 'PromoCtrl as vm',
        },
      },
    })

    .state('admin.promo_campaigns.promo.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/campaigns/promos/edit/edit.html',
          controller: 'PromoEditCtrl as vm',
        },
      },
    })

    .state('admin.promo_campaigns.promo.codes', {
      url: '/:promoId/codes',
      views: {
        '@': {
          templateUrl: 'app/admin/campaigns/promos/codes/codes.html',
          controller: 'PromoCodeCtrl as vm',
        },
      },
    })

    .state('admin.promo_campaigns.promo.codes.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/campaigns/promos/codes/edit/edit.html',
          controller: 'PromoCodeEditCtrl as vm',
        },
      },
    })

    .state('admin.shelfie_elements', {
      url: '/shelfie_elements',
      views: {
        '@': {
          templateUrl: 'app/admin/shelfies/shelfies.html',
          controller: 'ShelfieElementsCtrl as vm',
        },
      },
    })

    .state('admin.storyboard_elements', {
      url: '/storyboard_elements',
      views: {
        '@': {
          templateUrl: 'app/admin/storyboards/storyboards.html',
          controller: 'StoryboardElementsCtrl as vm',
        },
      },
    })

    .state('admin.challenges', {
      url: '/challenges',
      views: {
        '@': {
          templateUrl: 'app/admin/challenges/challenges.html',
          controller: 'ChallengesCtrl as vm',
        },
      },
    })

    .state('admin.pack_maintenance', {
      url: '/pack_maintenance',
      views: {
        '@': {
          templateUrl: 'app/admin/pack_maintenance/pack_maintenance.html',
          controller: 'PackMaintenanceCtrl as vm',
        },
      },
    })

    .state('admin.event_calendars', {
      url: '/drops',
      views: {
        '@': {
          templateUrl: 'app/admin/event_calendars/event_calendars.html',
          controller: 'EventCalendarsCtrl as vm',
        },
      },
    })

    .state('admin.event_calendars.waitlist', {
      url: '/:id/waitlist',
      views: {
        '@': {
          templateUrl: 'app/admin/event_calendars/waitlist/waitlist.html',
          controller: 'AdminSetsWaitlistCtrl as vm',
        },
      },
    })

    .state('admin.challenges.edit', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/admin/challenges/edit/edit.html',
          controller: 'ChallengesEditCtrl as vm',
        },
      },
    })

    /**
     * Publisher Routes
     */
    .state('pub', {
      url: '/publisher',
      abtract: true,
    })

    .state('pub.home', {
      url: '/home',
      views: {
        '@': {
          templateUrl: 'app/publisher/home/home.html',
          controller: 'HomeCtrl as vm',
        },
      },
    })

    .state('pub.intro', {
      url: '/intro',
      views: {
        '@': {
          templateUrl: 'app/publisher/intro/intro.html',
          controller: 'IntroCtrl as vm',
        },
      },
    })

    .state('pub.drops', {
      url: '/drops',
      views: {
        '@': {
          templateUrl: 'app/publisher/drop/drop.html',
          controller: 'DropCtrl as vm',
        },
      },
    })

    .state('pub.drops.edit', {
      url: '/edit/:id',
      views: {
        '@': {
          templateUrl: 'app/publisher/drop/edit/edit.html',
          controller: 'DropEditCtrl as vm',
        },
      },
    })

    .state('pub.drops.translation', {
      url: '/:parentId/translation',
      views: {
        '@': {
          templateUrl: 'app/publisher/drop/translation/translation.html',
          controller: 'TranslationDropCtrl as vm',
        },
      },
    })

    .state('pub.drops.translation.edit', {
      url: '/:translationId/edit',
      views: {
        '@': {
          templateUrl: 'app/publisher/drop/translation/edit/edit.html',
          controller: 'TranslationDropEditCtrl as vm',
        },
      },
    })

    .state('pub.drops.waitlist', {
      url: '/:id/waitlist',
      views: {
        '@': {
          templateUrl: 'app/publisher/drop/waitlist/waitlist.html',
          controller: 'DropsWaitlistCtrl as vm',
        },
      },
    })

    .state('pub.channels', {
      url: '/channels',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/channel.html',
          controller: 'ChannelCtrl as vm',
        },
      },
    })

    .state('pub.channels.create', {
      url: '/create',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/edition/edition.html',
          controller: 'ChannelEditionCtrl as vm',
        },
      },
    })

    .state('pub.channels.edit', {
      url: '/edit/:id',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/edition/edition.html',
          controller: 'ChannelEditionCtrl as vm',
        },
      },
    })

    .state('pub.channels.related', {
      url: '/:parentId/related',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/related/related.html',
          controller: 'RelatedCtrl as vm',
        },
      },
    })

    .state('pub.channels.translation', {
      url: '/:parentId/translation',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/translation/translation.html',
          controller: 'TranslationChannelCtrl as vm',
        },
      },
    })

    .state('pub.channels.top_prizes', {
      url: '/:parentId/top_prizes',
      views: {
        '@': {
          templateUrl: 'app/publisher/top_prizes/top_prizes.html',
          controller: 'TopPrizeCtrl as vm',
        },
      },
    })

    .state('pub.channels.top_prizes.raffles', {
      url: '/:topPrizeId/raffles',
      views: {
        '@': {
          templateUrl: 'app/publisher/top_prizes/raffles/raffles.html',
          controller: 'RafflesCtrl as vm',
        },
      },
    })

    .state('pub.channels.top_prizes.raffles.view', {
      url: '/:id',
      views: {
        '@': {
          templateUrl: 'app/publisher/top_prizes/raffles/view/raffles.view.html',
          controller: 'RafflesViewCtrl as vm',
        },
      },
    })

    .state('pub.channels.translation.edit', {
      url: '/:translationId/edit',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/translation/edit/edit.html',
          controller: 'TranslationChannelEditCtrl as vm',
        },
      },
    })

    .state('pub.channels.sets', {
      url: '/:parentId/sets',
      views: {
        '@': {
          templateUrl: 'app/publisher/sets/sets.html',
          controller: 'SetsCtrl as vm',
        },
      },
    })

    .state('pub.channels.sets.create', {
      url: '/create',
      views: {
        '@': {
          templateUrl: 'app/publisher/sets/edition/edition.html',
          controller: 'SetsEditionCtrl as vm',
        },
      },
    })

    .state('pub.channels.sets.edit', {
      url: '/edit/:id',
      views: {
        '@': {
          templateUrl: 'app/publisher/sets/edition/edition.html',
          controller: 'SetsEditionCtrl as vm',
        },
      },
    })

    .state('pub.channels.sets.waitlist', {
      url: '/:id/waitlist',
      views: {
        '@': {
          templateUrl: 'app/publisher/sets/waitlist/waitlist.html',
          controller: 'SetsWaitlistCtrl as vm',
        },
      },
    })

    .state('pub.set_checklists', {
      url: '/sets/:parentId/checklists',
      views: {
        '@': {
          templateUrl: 'app/publisher/set_checklist/set_checklist.html',
          controller: 'SetChecklistsCtrl as vm',
        },
      },
    })

    .state('pub.collectibles', {
      url: '/sets/:parentId/collectibles',
      views: {
        '@': {
          templateUrl: 'app/publisher/collectibles/collectibles.html',
          controller: 'CollectiblesCtrl as vm',
        },
      },
    })

    .state('pub.collectibles.shinies', {
      url: '/:collectibleId/shinies',
      views: {
        '@': {
          templateUrl: 'app/publisher/collectibles/shinies/shinies.html',
          controller: 'ShiniesCtrl as vm',
        },
      },
    })

    .state('pub.collectibles.shinies.odds', {
      url: '/:shinyId/odds',
      views: {
        '@': {
          templateUrl: 'app/publisher/collectibles/shinies/odds/odds.html',
          controller: 'ShiniesOddsCtrl as vm',
        },
      },
    })

    .state('pub.collectibles.create', {
      url: '/create',
      views: {
        '@': {
          templateUrl: 'app/publisher/collectibles/edition/edition.html',
          controller: 'CollectiblesEditionCtrl as vm',
        },
      },
    })

    .state('pub.collectibles.edit', {
      url: '/edit/:id',
      views: {
        '@': {
          templateUrl: 'app/publisher/collectibles/edition/edition.html',
          controller: 'CollectiblesEditionCtrl as vm',
        },
      },
    })

    .state('pub.collectibles.qmf', {
      url: '/qmf',
      views: {
        '@': {
          templateUrl: 'app/publisher/collectibles/qmf/qmf.html',
          controller: 'QMFCtrl as vm',
        },
      },
    })

    .state('pub.games', {
      url: '/publisher/channels/:channelId/games',
      views: {
        '@': {
          templateUrl: 'app/publisher/games/games.html',
          controller: 'GamesCtrl as vm',
        },
      },
    })

    .state('pub.games.create', {
      url: '/create',
      views: {
        '@': {
          templateUrl: 'app/publisher/games/edit/edit.html',
          controller: 'GameEditCtrl as vm',
        },
      },
    })

    .state('pub.games.edit', {
      url: '/:gameId/edit',
      views: {
        '@': {
          templateUrl: 'app/publisher/games/edit/edit.html',
          controller: 'GameEditCtrl as vm',
        },
      },
    })

    .state('pub.bundles', {
      url: '/sets/:parentId/bundles?channelId',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/bundles.html',
          controller: 'BundlesCtrl as vm',
        },
      },
    })

    .state('pub.bundles.create', {
      url: '/create',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/edition/edition.html',
          controller: 'BundlesEditionCtrl as vm',
        },
      },
    })

    .state('pub.bundles.step1', {
      url: '/step1/:id?event&create&post',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/step1/step1.html',
          controller: 'Step1Ctrl as vm',
        },
      },
    })

    .state('pub.bundles.from_this_channel', {
      url: '/from_this_channel/:id?event&create&post',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/from_this_channel/from_this_channel.html',
          controller: 'FromThisChannelCtrl as vm',
        },
      },
    })

    .state('pub.bundles.step2', {
      url: '/step2/:id?event&create&post',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/step2/step2.html',
          controller: 'Step2Ctrl as vm',
        },
      },
    })

    .state('pub.bundles.step3', {
      url: '/step3/:id?event&create&post',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/step3/step3.html',
          controller: 'Step3Ctrl as vm',
        },
      },
    })

    .state('pub.bundles.step4', {
      url: '/step4/:id?event&create&post',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/step4/step4.html',
          controller: 'Step4Ctrl as vm',
        },
      },
    })

    .state('pub.bundles.step5', {
      url: '/step5/:id?event&create&post',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/step5/step5.html',
          controller: 'Step5Ctrl as vm',
        },
      },
    })

    .state('pub.bundles.step6', {
      url: '/step6/:id',
      views: {
        '@': {
          templateUrl: 'app/publisher/bundles/step6/step6.html',
          controller: 'Step6Ctrl as vm',
        },
      },
    })

    .state('pub.reviews', {
      url: '/sets/:parentId/reviews',
      views: {
        '@': {
          templateUrl: 'app/publisher/reviews/reviews.html',
          controller: 'ReviewsCtrl as vm',
        },
      },
    })

    .state('pub.channels.posts', {
      url: '/:parentId/channel_posts?event&create',
      views: {
        '@': {
          templateUrl: 'app/publisher/posts/posts.html',
          controller: 'PostsCtrl as vm',
        },
      },
    })

    .state('pub.channels.posts.edit', {
      url: '/:id/edit',
      views: {
        '@': {
          templateUrl: 'app/publisher/posts/edit/edit.html',
          controller: 'PostsEditCtrl as vm',
        },
      },
    })

    .state('pub.comments', {
      url: '/channel_posts/:parentId/comments',
      views: {
        '@': {
          templateUrl: 'app/publisher/posts/comments/comments.html',
          controller: 'PostCommentsCtrl as vm',
        },
      },
    })

    .state('pub.channels.users', {
      url: '/:parentId/user_posts',
      views: {
        '@': {
          templateUrl: 'app/publisher/channel/users/users.html',
          controller: 'ChannelUsersCtrl as vm',
        },
      },
    })

    .state('pub.profile', {
      url: '/profile',
      views: {
        '@': {
          templateUrl: 'app/publisher/profile/profile.html',
          controller: 'ProfileCtrl as vm',
        },
      },
    })

    .state('pub.logo', {
      url: '/logo',
      views: {
        '@': {
          templateUrl: 'app/publisher/logo/logo.html',
          controller: 'LogoCtrl as vm',
        },
      },
    })

    .state('pub.products', {
      url: '/products',
      views: {
        '@': {
          templateUrl: 'app/publisher/products/products.html',
          controller: 'ProductsCtrl as vm',
        },
      },
    })
}
